import { defineMessages } from 'react-intl';

export const referenceRatesMessages = defineMessages({
    referenceRates: {
        id: 'reference-rates',
        defaultMessage: 'Reference rates',
    },
    referenceRate: {
        id: 'reference-rate',
        defaultMessage: 'Reference rate',
    },
    rates: {
        id: 'rates',
        defaultMessage: 'Rates',
    },
    rate: {
        id: 'rate-single',
        defaultMessage: 'Rate',
    },
    code: {
        id: 'reference-rate-code',
        defaultMessage: 'Code',
    },
    currentValue: {
        id: 'reference-rate-current-value',
        defaultMessage: 'Current value',
    },
    noCurrentValue: {
        id: 'reference-rate-no-current-value',
        defaultMessage: 'No value covers today',
    },
    noCurrentValueHint: {
        id: 'reference-rate-no-current-value-hint',
        defaultMessage: 'This rate has no value covering today. Add a value before indexing a pricing policy to it.',
    },
    isActive: {
        id: 'reference-rate-is-active',
        defaultMessage: 'Is active',
    },
    referenceRateDashboard: {
        id: 'reference-rate-dashboard',
        defaultMessage: 'Reference rate dashboard',
    },
    backToAllReferenceRates: {
        id: 'back-to-all-reference-rates',
        defaultMessage: 'Back to all reference rates',
    },
    createReferenceRateSuccess: {
        id: 'create-reference-rate-success',
        defaultMessage: 'Reference rate created',
    },
    createReferenceRateSuccessDescription: {
        id: 'create-reference-rate-success-description',
        defaultMessage: 'Reference rate {entry} has been successfully created.',
    },
    addReferenceRateSubtitle: {
        id: 'add-reference-rate-subtitle',
        defaultMessage: 'Create a new reference rate',
    },
    editReferenceRateSubtitle: {
        id: 'edit-reference-rate-subtitle',
        defaultMessage: 'Edit reference rate {entity}',
    },
    updateReferenceRateSuccess: {
        id: 'update-reference-rate-success',
        defaultMessage: 'Reference rate updated',
    },
    updateReferenceRateSuccessDescription: {
        id: 'update-reference-rate-success-description',
        defaultMessage: 'Reference rate {entity} has been successfully updated.',
    },
    deleteReferenceRate: {
        id: 'delete-reference-rate',
        defaultMessage: 'Delete reference rate',
    },
    deleteReferenceRateSubtitle: {
        id: 'delete-reference-rate-subtitle',
        defaultMessage: 'Permanently delete reference rate {entity}',
    },
    confirmDeleteReferenceRate: {
        id: 'confirm-delete-reference-rate',
        defaultMessage: 'Are you sure you want to delete this reference rate? This action cannot be undone.',
    },
    deleteReferenceRateSuccess: {
        id: 'delete-reference-rate-success',
        defaultMessage: 'Reference rate deleted',
    },
    deleteReferenceRateSuccessDescription: {
        id: 'delete-reference-rate-success-description',
        defaultMessage: 'The reference rate has been successfully deleted.',
    },
    currencyLockedHint: {
        id: 'reference-rate-currency-locked-hint',
        defaultMessage: 'The currency cannot be changed once a pricing policy is indexed to this rate.',
    },
    // Server error codes (see the indexed pricing API contract).
    deleteReferenceRateInUseError: {
        id: 'custom-error:delete_reference_rate_in_use',
        defaultMessage:
            'This reference rate has values or pricing policies and cannot be deleted. Deactivate it instead.',
    },
    changeReferenceRateCurrencyError: {
        id: 'custom-error:change_reference_rate_currency',
        defaultMessage: 'The currency cannot be changed while pricing policies are indexed to this rate!',
    },
});
